import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { Sun, Moon, Monitor } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import useUiStore from '../stores/uiStore';

const modes = ['light', 'system', 'dark'];

const DarkModeToggle = ({ sx }) => {
  const { t } = useTranslation('common');
  const themeMode = useUiStore((s) => s.themeMode);
  const setThemeMode = useUiStore((s) => s.setThemeMode);
  const { setMode } = useColorScheme();

  const modeConfig = {
    light: { icon: Sun, label: t('app.themeLight', 'Hell') },
    system: { icon: Monitor, label: t('app.themeSystem', 'System') },
    dark: { icon: Moon, label: t('app.themeDark', 'Dunkel') },
  };

  const handleToggle = () => {
    const currentIndex = modes.indexOf(themeMode);
    const nextMode = modes[(currentIndex + 1) % modes.length];
    setThemeMode(nextMode);
    setMode(nextMode);
  };

  const { icon: Icon, label } = modeConfig[themeMode] || modeConfig.system;

  return (
    <Tooltip title={label} arrow>
      <IconButton
        onClick={handleToggle}
        aria-label={t('app.colorScheme', 'Farbschema: {{mode}}', { mode: label })}
        size="small"
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2.5,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          color: 'text.primary',
          '&:hover': { bgcolor: 'action.hover' },
          ...sx,
        }}
      >
        <Icon size={20} weight="duotone" />
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
